<template>
  <div class="main-container">
    <!-- style="position: relative;" -->
    <!-- particles.js container -->
    <!-- <div id="particles-js"></div> -->
    <!-- <CustomHtml />
    <HeaderOptions />
    <HeaderAds />
    <Header />
    <Banner />
    <Title />
    <TitleInformation />
    <Dates />
    <Sponsor />
    <Ubication />
    <ImportantInformation />
    <Organizer />
    <Distribution />
    <Prices />
    <Multimedia />
    <Questions />
    <Footer />
    <AnimationBanner />
    <AnimationPeter />
    <AnimationPirates />
    <SimpleImage />
    <SpecialMessi />
    <AnimationTheater />
    <AnimationInfo />
    <AnimateRibbon />
    <GranjaScroll />
    <CenterImage />
    <VibraBanner />
    <ImageBtn />
    <ContentBackground />
    <FixBtn />
    <Tabs /> -->
    <div>
      <CookieModal></CookieModal>
      <component v-for="(section, index) of sections" :key="index" :is="section.key" :content="section.content">
      </component>
    </div>
  </div>
</template>
<script>
import api from '../api';

// const dataGeneral = require('../../data/example.json');
const CookieModal = () => Promise.resolve(import('../components/cookies/CookieModal.vue'))
const CustomHtml = () => Promise.resolve(import('../components/premium/CustomHtml.vue'));
const CountDown = () => Promise.resolve(import('../components/premium/CountDown.vue'));
const HeaderOptions = () => Promise.resolve(import('../components/premium/HeaderOptions.vue'));
const Header = () => Promise.resolve(import('../components/premium/Header.vue'));
const HeaderAds = () => Promise.resolve(import('../components/premium/HeaderAds.vue'));
const Banner = () => Promise.resolve(import('../components/premium/Banner.vue'));
const SlideBanner = () => Promise.resolve(import('../components/premium/BannerSlide.vue'));
const Title = () => Promise.resolve(import('../components/premium/Title.vue'));
const Dates = () => Promise.resolve(import('../components/premium/Dates.vue'));
const Sponsor = () => Promise.resolve(import('../components/premium/Sponsor.vue'));
const Ubication = () => Promise.resolve(import('../components/premium/Ubication.vue'));
const Organizer = () => Promise.resolve(import('../components/premium/Organizer.vue'));
const Distribution = () => Promise.resolve(import('../components/premium/Distribution.vue'));
const TitleInformation = () => Promise.resolve(import('../components/premium/TitleInformation.vue'));
const ImportantInformation = () => Promise.resolve(import('../components/premium/ImportantInformation.vue'));
const Prices = () => Promise.resolve(import('../components/premium/Prices.vue'));
const Multimedia = () => Promise.resolve(import('../components/premium/Multimedia.vue'));
const SimpleMultimedia = () => Promise.resolve(import('../components/premium/SimpleMultimedia.vue'));
const Questions = () => Promise.resolve(import('../components/premium/Questions.vue'));
const QuestionsCustom = () => Promise.resolve(import('../components/premium/QuestionsCustom.vue'));
const Footer = () => Promise.resolve(import('../components/premium/Footer.vue'));
const SocialNetworks = () => Promise.resolve(import('../components/premium/SocialNetworks.vue'));
const GlobalSection = () => Promise.resolve(import('../components/premium/GlobalSection.vue'));
const FpfShareEvent = () => Promise.resolve(import('../components/premium/FpfShareEvent.vue'));
const FpfFooter = () => Promise.resolve(import('../components/premium/FpfFooter.vue'));
const FpfFaqs = () => Promise.resolve(import('../components/premium/FpfFaqs.vue'));
const Publicity = () => Promise.resolve(import('../components/premium/Publicity.vue'));
const TYC = () => Promise.resolve(import('../components/premium/Description.vue'));
const AnimationBanner = () => Promise.resolve(import('../components/premium/AnimationBanner.vue'));
const AnimationPeter = () => Promise.resolve(import('../components/premium/AnimationPeter.vue'));
const MainBanner = () => Promise.resolve(import('../components/premium/MainBanner.vue'));
const AnimationPirates = () => Promise.resolve(import('../components/premium/AnimationPirates.vue'));
const SimpleImage = () => Promise.resolve(import('../components/premium/SimpleImage.vue'));
const SpecialMessi = () => Promise.resolve(import('../components/premium/SpecialMessi.vue'));
const Tabs = () => Promise.resolve(import('../components/premium/Tabs.vue'));
const AnimationTheater = () => Promise.resolve(import('../components/premium/AnimationTheater.vue'));
const Carousel = () => Promise.resolve(import('../components/premium/Carousel.vue'));
const AnimationInfo = () => Promise.resolve(import('../components/premium/AnimationInfo.vue'));
const AnimationOktober = () => Promise.resolve(import('../components/premium/AnimationOktober.vue'));
const InfoOktober = () => Promise.resolve(import('../components/premium/InfoOktober.vue'));
const Messiv2 = () => Promise.resolve(import('../components/premium/Messiv2.vue'));
const AnimateRibbon = () => Promise.resolve(import('../components/premium/AnimateRibbon.vue'));
const BannerAndCarousel = () => Promise.resolve(import('../components/premium/BannerAndCarousel.vue'));
const GranjaScroll = () => Promise.resolve(import('../components/premium/GranjaScroll.vue'));
const CenterImage = () => Promise.resolve(import('../components/premium/CenterImage.vue'));
const ModalInteraction = () => Promise.resolve(import('../components/premium/ModalInteraction.vue'));
const VibraBanner = () => Promise.resolve(import('../components/premium/VibraBanner.vue'));
const ImageBtn = () => Promise.resolve(import('../components/premium/ImageBtn.vue'));
const ContentBackground = () => Promise.resolve(import('../components/premium/ContentBackground.vue'));
const FixBtn = () => Promise.resolve(import('../components/premium/FixBtn.vue'));

const { VUE_APP_VERSION } = process.env;

export default {
  components: {
    CookieModal,
    CustomHtml,
    CountDown,
    HeaderOptions,
    Header,
    HeaderAds,
    Banner,
    SlideBanner,
    Title,
    Dates,
    TYC,
    Sponsor,
    Ubication,
    Organizer,
    Distribution,
    TitleInformation,
    ImportantInformation,
    Prices,
    Questions,
    QuestionsCustom,
    Footer,
    Multimedia,
    SimpleMultimedia,
    SocialNetworks,
    GlobalSection,
    FpfShareEvent,
    FpfFooter,
    FpfFaqs,
    Publicity,
    AnimationBanner,
    AnimationPeter,
    MainBanner,
    AnimationPirates,
    SimpleImage,
    SpecialMessi,
    Tabs,
    AnimationTheater,
    Carousel,
    AnimationInfo,
    AnimationOktober,
    InfoOktober,
    Messiv2,
    AnimateRibbon,
    BannerAndCarousel,
    GranjaScroll,
    CenterImage,
    ModalInteraction,
    VibraBanner,
    ImageBtn,
    ContentBackground,
    FixBtn
  },
  data() {
    return {
      sections: [],
      header: {},
      headerAds: {},
      headerAnimation: {},
      cssLink: null,
    };
  },
  created() {
    this.loadStyle();
  },
  mounted() {
    this.loadAnalytics();
    this.init();
    /* TODO: hacer que  se ejecute solo cuando se renderizan las secciones */
    setInterval(() => {
      this.initFixedButton();
    }, 1000);
  },
  destroyed() {
    if (this.cssLink) this.cssLink.remove();
  },
  methods: {
    async init() {
      const { slug } = this.$route.params;
      let response;
      try {
        response = await fetch(api.getSectionsJSONURL(slug));
        const { sections, redirect } = await response.json();
        if (redirect) {
          window.location.href = redirect;
          return;
        }
        this.sections = sections;
        this.$store.commit('setSections', sections);
      } catch (error) {
        this.messageToast('warning', 'Mensaje', 'No se pudo completar la acción, inténtelo de nuevo.');
      }
      if (response) {
        if (response.status === 403 || response.status === 404) {
          this.$router.push({ name: 'Error404' });
        }
        if (response.status === 500) {
          this.$router.push({ name: 'Error500' });
        }
        if (response.status === 502) {
          this.$router.push({ name: 'Error502' });
        }
        if (response.status === 503) {
          this.$router.push({ name: 'Error503' });
        }
      }
    },
    initFixedButton() {
      const $button = document.querySelector('.fixed-down');
      const $fixed = document.querySelector('.fixed-down-style');
      if (!$button || $fixed) return;
      const display = window.getComputedStyle($button).getPropertyValue('display');
      const $clonedButton = $button.cloneNode(true);
      $clonedButton.classList.add('fixed-down-style');
      document.body.appendChild($clonedButton);
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const hideFixed = entry.isIntersecting || entry.boundingClientRect.bottom <= 0;
          if (hideFixed) {
            $clonedButton.style.display = 'none';
          } else {
            $clonedButton.style.display = display;
          }
        });
      }, options);
      observer.observe($button);
    },
    async loadStyle() {
      const { slug } = this.$route.params;
      const head = document.getElementsByTagName('head')[0];
      const cssId = 'styleEvent';
      if (!document.getElementById(cssId)) {
        const link = document.createElement('link');
        this.cssLink = link;
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `https://cdn.joinnus.com/files_cache/css_${slug.toLowerCase()}.css?v=${VUE_APP_VERSION}`;
        // link.href = `/css_libido-en-piura.css`;
        link.media = 'all';
        head.appendChild(link);
      }
    },
  },
};
</script>
